import React from 'react'
import { useGetRelationsOutByIdQuery } from '../../../services/objects';
import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { LabelMedium } from 'baseui/typography';
import { useStyletron } from 'baseui';
import { Notification } from "baseui/notification";
import { FormattedMessage } from 'react-intl';
import { GoInfo } from 'react-icons/go';

const ReferencedCountersList = (props) => {
    const [css, theme] = useStyletron();
    const { data: refCounters, isLoading, isSuccess } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'IsRateOf' })
    const hasRefCounters = refCounters && refCounters.length > 0;
    const countersList = refCounters?.map((item) => <ListPanelWrapper key={item.id} {...item}></ListPanelWrapper>)

    return (
        <>
            {hasRefCounters &&
                <>
                    <Notification kind='info' overrides={{
                        Body: {
                            style: ({ $theme }) => ({
                                width: "auto",
                                marginLeft: 0,
                                marginRight: 0
                            })
                        }
                    }}><FormattedMessage id="ReferencedCountersList.EditEnergyRateNote" defaultMessage={'Changes on this rate will apply to the following referenced Energy meters'}></FormattedMessage>
                    </Notification>
                </>
            }
            <ul
                className={css({
                    paddingLeft: 0,
                    paddingRight: 0,
                    minWidth: '400px',
                    maxHeight: props.maxHeight ?? '400px',
                    overflow: "auto"
                })}
            >
                {countersList}
            </ul>
        </>
    )
}


export default ReferencedCountersList
